<script>
  export let score;
  export let plays;

  const INNINGS = 9;
</script>

<div class='game-score-innings game-score-innings-{plays.length}'>
  {#each score as inning, idx}
    {#if plays[idx]}
      <div class='game-score-innings-inning'> {inning} </div>
    {:else}
      <div class='game-score-innings-inning'> X </div>
    {/if}
  {/each}

  {#if plays.length > INNINGS}
    <div class='game-score-innings-extra'> {score.filter((_, index) => index >= INNINGS).reduce((a, b) => a + b)} </div>
  {/if}
</div>

<style>
  .game-score-innings {
    display: flex;
    gap: 10px;
  }

  .game-score-innings-inning {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 30px;
    height: 20px;
  }

  .game-score-innings-extra {
    display: none;
    justify-content: center;
    align-items: center;

    width: 30px;
    height: 20px;
  }

  @media only screen and (max-width: 1100px) {
    :not(.game-score-innings-10) > .game-score-innings-inning:nth-child(n + 10) {
      display: none;
    }

    :not(.game-score-innings-10) > .game-score-innings-extra {
      display: flex;
    }
  }
</style>
